// An input or textarea with its label and hint wired up. The code variant
// is the one-time code: numeric, centred, spaced, filled by the keyboard.
import { useId, type InputHTMLAttributes, type TextareaHTMLAttributes } from 'react';
import { cx } from './cx';

export interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  multiline?: boolean;
  rows?: number;
  /** A one-time code. */
  code?: boolean;
}

export function Field({ label, hint, multiline, rows = 4, code, id: given, className, ...rest }: FieldProps) {
  const own = useId();
  const id = given ?? own;
  const hintId = hint ? `${id}-hint` : undefined;
  const codeProps = code ? { inputMode: 'numeric' as const, autoComplete: 'one-time-code', pattern: '[0-9 ]*' } : {};
  return (
    <div className={cx('field-wrap', className)}>
      {label && <label htmlFor={id} className="field-label">{label}</label>}
      {multiline
        ? <textarea id={id} className="field" rows={rows} aria-describedby={hintId} {...(rest as TextareaHTMLAttributes<HTMLTextAreaElement>)} />
        : <input id={id} className={cx('field', code && 'code num')} aria-describedby={hintId} {...codeProps} {...rest} />}
      {hint && <p id={hintId} className="field-hint">{hint}</p>}
    </div>
  );
}
